// RegisterSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import {
  UserRegistration,
  GSTDetailsResponse,
  RegisterState,
  OrganisationDetailsResponse,
} from "../types";
import {
  userRegistrationThunk,
  fetchGSTDetailsThunk,
  submitUserRegistrationDetailsThunk,
} from "./thunk/registerThunk";

const initialState: RegisterState = {
  id: 0,
  name: "",
  email: "",
  mobile_number: "",
  dob: "",
  address: "",
  gstDetails: undefined,
  userDetails: undefined,
};

const RegisterSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setUserRegistration: (state, action) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.mobile_number = action.payload.mobile_number;
      state.dob = action.payload.dob;
      state.address = action.payload.address;
    },

    resetUserRegistration: () => initialState,
    setGSTDetails: (state, action) => {
      state.gstDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ User Registration API
      // .addCase(
      //   userRegistrationThunk.fulfilled,
      //   (state: RegisterState, action: { payload: UserRegistration }) => {
      //     state.id = action.payload.id;
      //     state.name = action.payload.name;
      //     state.email = action.payload.email;
      //     state.mobile_number = action.payload.mobile_number;
      //     state.dob = action.payload.dob;
      //     state.address = action.payload.address;
      //     // 🔹 Leave gstDetails untouched
      //   }
      // )
      // .addCase(userRegistrationThunk.rejected, (state: RegisterState) => {
      //   // Reset only user info, not GST
      //   state.id = 0;
      //   state.name = "";
      //   state.email = "";
      //   state.mobile_number = "";
      //   state.dob = "";
      //   state.address = "";
      // })

      // ✅ GST Details API
      .addCase(
        fetchGSTDetailsThunk.fulfilled,
        (state: RegisterState, action: { payload: GSTDetailsResponse }) => {
          state.gstDetails = action.payload;
        }
      )
      .addCase(fetchGSTDetailsThunk.rejected, (state: RegisterState) => {
        state.gstDetails = undefined;
      })
      .addCase(
        submitUserRegistrationDetailsThunk.fulfilled,
        (
          state: RegisterState,
          action: { payload: OrganisationDetailsResponse }
        ) => {
          state.userDetails = action.payload;
        }
      )
      .addCase(
        submitUserRegistrationDetailsThunk.rejected,
        (state: RegisterState) => {
          state.userDetails = undefined;
        }
      );
  },
});

export const { setUserRegistration, setGSTDetails, resetUserRegistration } =
  RegisterSlice.actions;
export default RegisterSlice.reducer;
